import { Button } from "./Button";
import { Modal } from "./Modal";

interface Props {
  open: boolean;
  currentStatus: "ENABLE" | "DISABLE" | undefined;
  setOpen: (open: boolean) => void;
  onChangeStatus: () => void;
  onCancel: () => void;
  storeDisplayName?: string;
}

export const ModalChangeStatusConfirm = ({
  open,
  currentStatus = "ENABLE",
  setOpen,
  onChangeStatus,
  onCancel,
  storeDisplayName = "店舗",
}: Props) => {
  return (
    <Modal open={open} onOpenChange={setOpen} className="2xl:w-[35vw]">
      {currentStatus == "ENABLE" ? (
        <DeactiveContent storeDisplayName={storeDisplayName} />
      ) : (
        <ActiveContent />
      )}

      <div className="flex justify-end gap-2 mt-4">
        <Button buttonType="text" onClick={onCancel} className="!h-12">
          キャンセル
        </Button>
        {currentStatus == "ENABLE" ? (
          <Button
            variant="solid"
            color="danger"
            onClick={onChangeStatus}
            className="!h-12"
          >
            無効にする
          </Button>
        ) : (
          <Button
            variant="solid"
            color="primary"
            onClick={onChangeStatus}
            className="!h-12"
          >
            有効にする
          </Button>
        )}
      </div>
    </Modal>
  );
};

const DeactiveContent = ({
  storeDisplayName = "店舗",
}: {
  storeDisplayName?: string;
}) => {
  return (
    <>
      <p className="text-lg font-bold leading-7">
        本当に無効にしてもよろしいですか？
      </p>
      <p className="text-sm leading-[1.375rem] p-4 mt-4 -mx-4 border-b border-grey-300">
        無効にすると、すべての{storeDisplayName}とユーザーが非表示になります。
        <br /> 本当に続行してもよろしいですか？
      </p>
    </>
  );
};

const ActiveContent = () => {
  return (
    <>
      <p className="text-lg font-bold leading-7">
        この会社を再度有効にしますか？
      </p>
      <p className="text-sm leading-[1.375rem] p-4 mt-4 -mx-4 border-b border-grey-300">
        再度有効化すると、すべてのデータは通常通りに動作します。
        <br /> 続行しますか？
      </p>
    </>
  );
};
